import { render, staticRenderFns } from "./EditPlant.vue?vue&type=template&id=67ac9a01&"
import script from "./EditPlant.vue?vue&type=script&lang=js&"
export * from "./EditPlant.vue?vue&type=script&lang=js&"
import style0 from "./EditPlant.vue?vue&type=style&index=0&id=67ac9a01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports